var map = {
	"./arrowTop.svg": "1db1",
	"./browserSafari.svg": "28b8",
	"./circle.svg": "af52",
	"./iconDribbble.svg": "36b2",
	"./iconFacebook.svg": "ce72",
	"./iconGithub.svg": "3465",
	"./iconInstagram.svg": "b956",
	"./iconLink.svg": "98f8",
	"./iconQiita.svg": "7983",
	"./iconSearch.svg": "cad3",
	"./iconTwitter.svg": "0b44",
	"./logo.svg": "7f9d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dcd6";